import { Alert } from "antd";
import React, { FC } from "react";
import * as Styled from "./LoadingContainer.css";
import { Spinner } from "src/components/Spinner";

export interface ILoadingContainer extends Styled.IContainer {
  errorMessage?: React.ReactNode;
}

export const LoadingContainer: FC<ILoadingContainer> = ({
  isLoading,
  isError,
  errorMessage,
}) => {
  const message = errorMessage ?? "Oops, something went wrong.";

  return (
    <Styled.Container isLoading={isLoading} isError={isError}>
      {isError ? (
        <Alert type="error" message={message} banner />
      ) : (
        /* It drew the right glyph but it did not TURN — no `spin`, so a
           static loading mark sat on the page — and it was painted
           #2178FF, a constant named BLUE_CRAYOLA that is the stale brand
           blue rather than this tenant's accent. */
        <Styled.SpinnerWrapper>
          <Spinner size={28} />
        </Styled.SpinnerWrapper>
      )}
    </Styled.Container>
  );
};
